var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "holder" }, [
      _c(
        "h2",
        { attrs: { id: "page-header" } },
        [
          _c("router-link", { attrs: { to: "/" } }, [_vm._v("My Arlington")]),
          _c("router-link", { attrs: { to: "/projects" } }, [
            _vm._v(" — Daily Infrastructure Work Around the County")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layer-page" }, [
      _c("div", { staticClass: "widget one-third filter-pane" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMobile || _vm.mobileMenu === false,
                expression: "isMobile || mobileMenu === false"
              }
            ],
            staticClass: "filter-header",
            attrs: {
              type: "button",
              id: "mobile-menu",
              "aria-expanded": _vm.mobileMenu ? "true" : "false",
              "aria-controls": "filters-and-settings"
            },
            on: {
              click: function($event) {
                _vm.mobileMenu = !_vm.mobileMenu
              }
            }
          },
          [
            _vm._v("\n                Filters and Location\n                "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.mobileMenu,
                    expression: "!mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mobileMenu,
                    expression: "mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMobile || _vm.mobileMenu,
                expression: "!isMobile || mobileMenu"
              }
            ],
            attrs: { id: "filters-and-settings" }
          },
          [
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isMobile,
                      expression: "!isMobile"
                    }
                  ],
                  staticClass: "filter-header",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.filtersExpanded ? "true" : "false",
                    "aria-controls": "projects-filter-list"
                  },
                  on: { click: _vm.filtersToggle }
                },
                [
                  _c("span", [
                    _vm._v("Filters\n                            "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filtersExpanded,
                            expression: "filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                    ),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.filtersExpanded,
                            expression: "!filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticStyle: { clear: "both", display: "block" }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filtersExpanded || _vm.mobileMenu,
                    expression: "filtersExpanded || mobileMenu"
                  }
                ],
                staticClass: "filterList",
                attrs: { id: "projects-filter-list" }
              })
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Zoom to Location")]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  staticClass: "filter-header",
                  on: { click: _vm.getCurrentLocation }
                },
                [_vm._v("Your Current Location")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-container zoom-container" },
              [
                _c("label", { attrs: { for: "addressSearch" } }, [
                  _vm._v("Address")
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("gmap-autocomplete", {
                  ref: "autocomplete",
                  attrs: {
                    id: "addressSearch",
                    placeholder: "Enter street address"
                  },
                  on: { place_changed: _vm.placeChanged }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c("label", { attrs: { for: "civicAssociation" } }, [
                _vm._v("Civic Association")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.civicAssocationsSelected,
                        expression: "civicAssocationsSelected"
                      }
                    ],
                    attrs: { id: "civicAssociation" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.civicAssocationsSelected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Select a civic association")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.civicAssociations, function(ca) {
                      return _c(
                        "option",
                        { key: ca.OBJECTID, domProps: { value: ca } },
                        [_vm._v(_vm._s(ca.LABEL))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.civicAssociationFailure,
                      expression: "civicAssociationFailure"
                    }
                  ]
                },
                [_vm._v("Unable to load Civic Assocations.")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  staticClass: "link filter-header",
                  on: { click: _vm.clearAll }
                },
                [_vm._v("Clear All")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "widget full-map-pane toggle-window" },
        [
          _c("div", { staticStyle: { position: "relative", top: "0" } }, [
            _c(
              "div",
              {
                staticClass: "toggle-bar",
                attrs: { role: "group", "aria-label": "Map or list" }
              },
              [
                _c(
                  "button",
                  {
                    class:
                      _vm.showMap === true
                        ? "toggle-link"
                        : "toggle-link active",
                    attrs: {
                      type: "button",
                      "aria-pressed": _vm.showMap === true
                    },
                    on: {
                      click: function($event) {
                        _vm.showMap = true
                      }
                    }
                  },
                  [_vm._v("Map")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class:
                      _vm.showMap === false
                        ? "toggle-link"
                        : "toggle-link active",
                    attrs: {
                      type: "button",
                      "aria-pressed": _vm.showMap === false,
                      id: "list-link"
                    },
                    on: {
                      click: function($event) {
                        _vm.showMap = false
                      }
                    }
                  },
                  [_vm._v("List")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "gmap-map",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMap,
                  expression: "showMap"
                }
              ],
              attrs: {
                center: _vm.mapCenter,
                zoom: _vm.zoomLevel,
                options: _vm.mapStyles,
                id: "vue-map-container",
                "aria-label": "Map of infrastructure projects"
              }
            },
            [
              _vm._l(_vm.filteredProjects, function(project) {
                return _c(
                  "div",
                  { key: project.id },
                  _vm._l(project.shapes, function(shape) {
                    return _c(
                      "div",
                      { key: project.id + "_" + shape },
                      [
                        shape.shape === "polygon"
                          ? _c("gmap-polygon", {
                              attrs: {
                                paths: shape.coordinates,
                                options: _vm.shapeOptions
                              },
                              on: {
                                click: function(e) {
                                  return _vm.shapeClick(project, e)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        shape.shape === "polyline"
                          ? _c("gmap-polyline", {
                              attrs: {
                                path: shape.coordinates,
                                options: _vm.shapeOptions
                              },
                              on: {
                                click: function(e) {
                                  return _vm.shapeClick(project, e)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        shape.shape === "marker"
                          ? _c("gmap-circle", {
                              key: shape.id,
                              attrs: {
                                center: shape.coordinates,
                                options: _vm.shapeOptions,
                                radius: 32
                              },
                              on: {
                                click: function(e) {
                                  return _vm.shapeClick(project, e)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              }),
              _vm._v(" "),
              _c(
                "gmap-info-window",
                {
                  attrs: {
                    opened: _vm.selectedInfoWindowPosition !== null,
                    position: _vm.selectedInfoWindowPosition
                  },
                  on: { closeclick: _vm.infoWindowCloseClick }
                },
                [
                  _c("div", { staticClass: "info-window" }, [
                    _c("b", [
                      !_vm.selectedItem.hideUrl
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.selectedItem.url,
                                target: "_blank"
                              },
                              domProps: {
                                innerHTML: _vm._s(_vm.selectedItem.title)
                              }
                            },
                            [_vm._v("Website")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedItem.hideUrl
                        ? _c(
                            "span",
                            {
                              domProps: {
                                innerHTML: _vm._s(_vm.selectedItem.title)
                              }
                            },
                            [_vm._v("Website")]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.selectedItem.content
                      ? _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.selectedItem.content)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedItem.buildingPermitList
                      ? _c(
                          "div",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "Project",
                                    params: { id: _vm.selectedItem.id }
                                  }
                                }
                              },
                              [_vm._v("Permits")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.selectedCoordinates
                ? _c("gmap-marker", {
                    attrs: { position: _vm.selectedCoordinates, radius: 24 }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.civicAssocationsSelected
                ? _c("gmap-polygon", {
                    attrs: {
                      path: _vm.civicAssocationsSelected.paths,
                      options: _vm.locationOptions
                    }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showMap,
                  expression: "!showMap"
                }
              ],
              staticClass: "list-pane"
            },
            _vm._l(_vm.filteredProjects, function(project) {
              return _c("div", { key: project.id, staticClass: "project" }, [
                _c(
                  "h3",
                  [
                    project.title
                      ? [
                          project.hideUrl
                            ? _c("a", {
                                domProps: { innerHTML: _vm._s(project.title) }
                              })
                            : _c("a", {
                                attrs: { href: project.url },
                                domProps: { innerHTML: _vm._s(project.title) }
                              })
                        ]
                      : [_vm._v("Project")]
                  ],
                  2
                ),
                _vm._v(" "),
                project.content
                  ? _c("p", {
                      staticClass: "no-vertical-margin",
                      domProps: { innerHTML: _vm._s(project.content) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                project.buildingPermitList
                  ? _c(
                      "p",
                      { staticClass: "no-vertical-margin" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "Project",
                                params: { id: project.id }
                              }
                            }
                          },
                          [_vm._v("Permits")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            }),
            0
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "blurb" } }, [
      _c("p", [
        _vm._v(
          "\n              Find infrastructure maintenance and repairs happening around the County. Don't see work represented on the map? It may be a Washington Gas, Dominion Power, VDOT, APS or private ownership project.\n              Or check our "
        ),
        _c("a", { attrs: { href: "https://my.arlingtonva.us/projects" } }, [
          _vm._v(" Projects pages")
        ]),
        _vm._v(".\n          ")
      ]),
      _vm._v(" "),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21d1e4e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d1e4e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/Projects.vue
// module id = 20d5
// module chunks = 1